module.exports = __webpack_public_path__ + "static/media/checkmark-green.ee7836c8.svg";